/**
 * Modellklasse für Restauranteinstellungen
 */
export class RestaurantSettings {
  constructor(data = {}) {
    this.id = data.id || null;
    this.name = data.name || '';
    this.description = data.description || '';
    this.logoUrl = data.logoUrl || '';
    this.address = data.address || '';
    this.city = data.city || '';
    this.postalCode = data.postalCode || '';
    this.country = data.country || '';
    this.phoneNumber = data.phoneNumber || '';
    this.email = data.email || '';
    this.website = data.website || '';
    this.vatNumber = data.vatNumber || '';
    this.taxRate = data.taxRate || 19;
    this.serviceChargePercentage = data.serviceChargePercentage || 0;
    this.currency = data.currency || 'EUR';
    this.openingHours = data.openingHours || {};
    this.enableOnlinePayment = data.enableOnlinePayment || false;
    this.paymentMethods = data.paymentMethods || ['cash', 'card'];
    this.enableOrderStatus = data.enableOrderStatus || true;
    this.enableCustomerReviews = data.enableCustomerReviews || false;
    this.enableDynamicTranslations = data.enableDynamicTranslations || false; // Neue Option
    this.supportedLanguages = data.supportedLanguages || ['de', 'en']; // Unterstützte Sprachen
    this.defaultLanguage = data.defaultLanguage || 'de'; // Standardsprache
  }

  /**
   * Konvertiert das Objekt in ein JSON-Objekt für API-Anfragen
   * @returns {Object} JSON-Objekt
   */
  toJSON() {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      logoUrl: this.logoUrl,
      address: this.address,
      city: this.city,
      postalCode: this.postalCode,
      country: this.country,
      phoneNumber: this.phoneNumber,
      email: this.email,
      website: this.website,
      vatNumber: this.vatNumber,
      taxRate: this.taxRate,
      serviceChargePercentage: this.serviceChargePercentage,
      currency: this.currency,
      openingHours: this.openingHours,
      enableOnlinePayment: this.enableOnlinePayment,
      paymentMethods: this.paymentMethods,
      enableOrderStatus: this.enableOrderStatus,
      enableCustomerReviews: this.enableCustomerReviews,
      enableDynamicTranslations: this.enableDynamicTranslations,
      supportedLanguages: this.supportedLanguages,
      defaultLanguage: this.defaultLanguage
    };
  }
} 